export const stats = {
  documentsAnalyzed: '250M+',
  ownersTracked: '26M+',
  operatingEntities: '19M+',
  coverage: '99%+',
} as const;
